import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Row, Col, FormGroup, Label, Input, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';
import { shouldToastError } from '../../../../Api/utils';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const FileCloseModal = ({ isOpen, toggle, arbitrationId, refreshArbitrationData }) => {
    const initialFormData = {
        willReapply: 'false',
        fileCloseDescription: '',
        fileCloseComment: '',
        fileCloseDescriptionOther: ''
    };

    const {
        formData,
        setFormData,
        handleCancel,
    } = useModalCrudState({
        isOpen,
        mode: 'add',
        selectedItem: null,
        initialData: initialFormData,
        toggle,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    // Tekrar başvuru bilgisini buton seçimine göre günceller
    const handleRadioChange = (value) => {
        setFormData(prev => ({
            ...prev,
            willReapply: value
        }));
    };

    // Dosya kapatma verisini doğrulayıp API'ye gönderir
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.fileCloseDescription.trim()) {
            toast.error('Dosya kapatma yorumu zorunludur.');
            return;
        }

        if (!formData.fileCloseComment.trim()) {
            toast.error('Ek yorum alanı zorunludur.');
            return;
        }

        if (formData.fileCloseDescription === 'Diğer' && !formData.fileCloseDescriptionOther.trim()) {
            toast.error('Diğer dosya kapatma yorumu zorunludur.');
            return;
        }

        setIsSubmitting(true);

        try {
            const apiData = {
                reapplicationInformation: {
                    arbitration: [arbitrationId],
                    willReapply: formData.willReapply === 'true',
                    willWriteExpertReport: false,
                    fileCloseDescription: formData.fileCloseDescription,
                    fileCloseDescriptionOther: formData.fileCloseDescription === 'Diğer' ? formData.fileCloseDescriptionOther : '',
                    comments: formData.fileCloseComment ? [{
                        commentType: "Genel",
                        comment: formData.fileCloseComment
                    }] : []
                },
                accidentFileCloseInformation: {
                    fileStatus: "Kapalı",
                    fileCloseDescription: formData.fileCloseDescription,
                    fileCloseDescriptionOther: formData.fileCloseDescription === 'Diğer' ? formData.fileCloseDescriptionOther : '',
                    fileCloseComment: formData.fileCloseComment
                }
            };

            const fileCloseApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/Arbitration/patch-arbitration-close';

            await handleAddModifyOperation({
                apiEndpoint: fileCloseApiUrl,
                selectedItem: { id: arbitrationId },
                mode: 'modify',
                data: apiData,
                httpMethod: 'PUT',
                refreshDataCallback: () => {
                    refreshArbitrationData();
                    handleCancel();
                },
                componentName: 'Dosya kapatma'
            });

        } catch (error) {
            if (shouldToastError(error)) {
                toast.error('Dosya kapatma işlemi sırasında hata oluştu. Lütfen tekrar deneyin.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} size="lg">
            <ModalHeader toggle={handleCancel}>
                Dosya Kapatma
            </ModalHeader>
            <ModalBody>
                <Alert color="warning" className="mb-4">
                    <i className="fa fa-warning me-2"></i>
                    Bu işlem tahkim dosyasını kapatacaktır. Lütfen gerekli bilgileri doldurun.
                </Alert>

                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-3">
                                <Label className="text-nowrap mb-2">Tekrar Başvuru Yapılacak Mı?</Label>
                                <div className="d-flex mt-2">
                                    <Button
                                        type="button"
                                        color={formData.willReapply === 'true' ? 'success' : 'outline-success'}
                                        className="me-3"
                                        onClick={() => {
                                            handleRadioChange('true');
                                        }}
                                    >
                                        Evet {formData.willReapply === 'true' && '✓'}
                                    </Button>
                                    <Button
                                        type="button"
                                        color={formData.willReapply === 'false' ? 'danger' : 'outline-danger'}
                                        onClick={() => {
                                            handleRadioChange('false');
                                        }}
                                    >
                                        Hayır {formData.willReapply === 'false' && '✓'}
                                    </Button>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-4">
                                <Label for="fileCloseDescription">Dosya Kapatma Yorumu <span className="text-danger">*</span></Label>
                                <Input
                                    type="select"
                                    name="fileCloseDescription"
                                    id="fileCloseDescription"
                                    value={formData.fileCloseDescription}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Dosya kapama sebebini seçin...</option>
                                    <option value="Sulh Anlaşması Nedeniyle">Sulh Anlaşması Nedeniyle</option>
                                    <option value="Eksper İncelemesi Sonucu Aracın Hasar Tutarının Eksik Olduğu Kanaatine Varıldığı">Eksper İncelemesi Sonucu Aracın Hasar Tutarının Eksik Olduğu Kanaatine Varıldığı</option>
                                    <option value="Sigortalı/Zarar Gören Tarafından İstenmediği">Sigortalı/Zarar Gören Tarafından İstenmediği</option>
                                    <option value="Sigortalının/Zarar Görenin Ulaşılamaması">Sigortalının/Zarar Görenin Ulaşılamaması</option>
                                    <option value="Eksper Raporu Alınıp İnceleme Yapıldıktan Sonra Dosyanın Gereksiz Olduğu Tespit Edildiği">Eksper Raporu Alınıp İnceleme Yapıldıktan Sonra Dosyanın Gereksiz Olduğu Tespit Edildiği</option>
                                    <option value="Başvurunun Yasal Süresi Geçtiği">Başvurunun Yasal Süresi Geçtiği</option>
                                    <option value="Maddi Hasarı Bulunmadığı">Maddi Hasarı Bulunmadığı</option>
                                    <option value="Yaralanma Söz Konusu Olmadığı">Yaralanma Söz Konusu Olmadığı</option>
                                    <option value="Dosyada Hukuki Problem Olduğu">Dosyada Hukuki Problem Olduğu</option>
                                    <option value="Evrakların Eksik/Hatalı Olduğu">Evrakların Eksik/Hatalı Olduğu</option>
                                    <option value="Sigortalı Aleyhine Haksızlık Olmadığı">Sigortalı Aleyhine Haksızlık Olmadığı</option>
                                    <option value="Objektif Kusur Değerlendirmesi">Objektif Kusur Değerlendirmesi</option>
                                    <option value="Başka Şirkete Dosya Açıldığı">Başka Şirkete Dosya Açıldığı</option>
                                    <option value="Mükerrer/Devam Dosyası Olduğu">Mükerrer/Devam Dosyası Olduğu</option>
                                    <option value="Ticari Araç Başvurusu Olduğu">Ticari Araç Başvurusu Olduğu</option>
                                    <option value="Basit Onarım İşi Olduğu">Basit Onarım İşi Olduğu</option>
                                    <option value="Başvurudan Vazgeçildiği">Başvurudan Vazgeçildiği</option>
                                    <option value="MEAEM Görevi Dışı Olduğu">MEAEM Görevi Dışı Olduğu</option>
                                    <option value="Bilgi Edinme Başvurusu Olduğu">Bilgi Edinme Başvurusu Olduğu</option>
                                    <option value="Ceza Avukatı Tutulduğu İçin Takip Edilmeyeceği">Ceza Avukatı Tutulduğu İçin Takip Edilmeyeceği</option>
                                    <option value="İcra Takibinin Başlatıldığı">İcra Takibinin Başlatıldığı</option>
                                    <option value="Dava Açıldığı">Dava Açıldığı</option>
                                    <option value="Şikayetin Geri Çekildiği">Şikayetin Geri Çekildiği</option>
                                    <option value="Diğer">Diğer</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>

                    {formData.fileCloseDescription === 'Diğer' && (
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-4">
                                    <Label for="fileCloseDescriptionOther">Manuel Dosya Kapatma Yorumu <span className="text-danger">*</span></Label>
                                    <Input
                                        type="textarea"
                                        name="fileCloseDescriptionOther"
                                        id="fileCloseDescriptionOther"
                                        value={formData.fileCloseDescriptionOther}
                                        onChange={handleInputChange}
                                        placeholder="Manuel dosya kapatma yorumunuzu buraya yazın..."
                                        rows="3"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-4">
                                <Label for="fileCloseComment">Ek Yorum <span className="text-danger">*</span></Label>
                                <Input
                                    type="textarea"
                                    name="fileCloseComment"
                                    id="fileCloseComment"
                                    value={formData.fileCloseComment}
                                    onChange={handleInputChange}
                                    placeholder="Dosya kapatma ile ilgili ek yorumlarınızı buraya yazın..."
                                    rows="3"
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleCancel} disabled={isSubmitting}>
                    İptal
                </Button>
                <Button
                    color="danger"
                    onClick={handleSubmit}
                    disabled={
                        isSubmitting || 
                        !formData.fileCloseDescription.trim() || 
                        !formData.fileCloseComment.trim() ||
                        (formData.fileCloseDescription === 'Diğer' && !formData.fileCloseDescriptionOther.trim())
                    }
                >
                    {isSubmitting ? 'Dosya Kapatılıyor...' : 'Dosyayı Kapat'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default FileCloseModal;
